import Company from "./Components/Company";

export default Company;
